module.exports = __webpack_public_path__ + "static/media/7.396802c1.svg";